<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`委托信息详情`"
    width="100vw"
    height="100vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm', 'areaTreeData')"
  >
    <el-form disabled v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item prop="reportCodeStart">
            <template #label>
              <div>
                <span>委托编号</span>
              </div>
            </template>
            <el-input v-model.trim="editForm.reportCodeStart" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model.trim="editForm.projectName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="委托单位" prop="client">
            <el-input v-model.trim="editForm.client" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="委托单位联系人" prop="sfcn">
            <el-input v-model.trim="editForm.sfcn" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式" prop="sfcp">
            <el-input v-model.trim="editForm.sfcp" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测地点" prop="testAddress">
            <el-input v-model.trim="editForm.testAddress" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目经理" prop="leaderId">
            <el-select v-model="editForm.leaderId" placeholder="请选择">
              <el-option v-for="item in userOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班组成员" prop="entrustmentUserIds">
            <el-select v-model="editForm.entrustmentUserIds" multiple placeholder="请选择">
              <el-option v-for="item in userOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="使用车辆" prop="supervisionUnit">
            <el-input v-model.trim="editForm.supervisionUnit" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测类别" prop="testType">
            <el-checkbox-group v-model="editForm.testType">
              <el-checkbox v-for="item in testTypeOptions" :key="item.code" :label="item.code">{{ item.name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <table class="word-table">
          <tr style="background-color: #f2f2f2">
            <td width="15%" class="label">检测项目</td>
            <td width="10%" class="label">数量</td>
            <td width="12.5%" class="label">试验项目</td>
            <td width="30%" class="label">现场图片</td>
            <td width="20%" class="label">检测清单</td>
            <td width="12.5%" class="label">工作量备注</td>
          </tr>
          <tr v-for="(item, index) in editForm.sampleInfoList" :key="index">
            <td class="align-Left">{{ item.testItemText }}</td>
            <td class="align-Left"><el-input type="number" v-model="item.cnt" style="width: 100%"></el-input></td>
            <td class="align-Left">
              <el-input type="textarea" v-model="item.expItems" style="width: 100%"></el-input>
            </td>
            <td class="align-Left">
              <div class="img-list">
                <el-image
                  v-for="(url, imgIndex) in item.imgList"
                  :key="imgIndex"
                  style="width: 88px; height: 88px"
                  :src="url"
                  :preview-src-list="item.imgList"
                ></el-image>
              </div>
            </td>
            <td class="align-Left">
              <div class="img-list">
                <el-link
                  type="primary"
                  :underline="true"
                  v-for="(file, index) in item.files"
                  :key="index"
                  :href="`${$imgUrl}${file.filePath}`"
                  target="_blank"
                >
                  {{ file.fileName }}
                </el-link>
              </div>
            </td>
            <td class="align-Left"><el-input type="textarea" v-model="item.remark" style="100"></el-input></td>
          </tr>
        </table>

        <el-col :span="12">
          <el-form-item label="商定检测日期" prop="sendDate">
            <el-date-picker
              v-model="editForm.sendDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              style="width: 200px"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户备注" prop="note">
            <el-input type="textarea" v-model="editForm.note" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报告领取方式" prop="deliveryType">
            <el-radio-group v-model="editForm.deliveryType">
              <el-radio :label="0">自取</el-radio>
              <el-radio :label="1">邮寄（到付）</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否邮寄" prop="isIvDdeliver">
            <div class="break-radio">
              <el-radio-group v-model="editForm.isIvDdeliver">
                <div class="radio-line">
                  <el-radio :label="1">是</el-radio>
                  <el-input
                    v-model="editForm.ivDdeliveryAddress"
                    placeholder="请输入邮寄地址"
                    style="width: 500px"
                    clearable
                  ></el-input>
                </div>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="内部备注" prop="noteInner">
            <el-input type="textarea" v-model="editForm.noteInner" placeholder="请输入（供内部查看）" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </div>
  </drag-dialog>
</template>

<script>
import { getDictsByCode } from '@/api/system';
import { getEntrustmentSet } from '@/api/entrust';
import { getUserListByCode } from '@/api/user';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      maxCode: '',
      editForm: {
        id: null,
        reportCodeStart: '', // 报告起始编号
        client: '', // 委托单位
        projectName: '', // 工程名称
        payOrg: '',
        builder: '',
        sfcn: '', // 送检人
        sfcp: '', // 联系电话
        sfca1: '', // 送检人地址部分1
        sfca2: '', // 送检人地址部分2
        sfca3: '', // 送检人地址部分3
        sfca: '', // 送检人地址部分4
        testType: [], // 检测类别
        supervisionUnit: '', // 使用车辆
        leaderId: null, // 项目经理
        entrustmentUserIds: [], // 班组成员
        isSbct: 0, // 是否接受分包至其他有资质的检测机构
        reportType: [0], // 出具报告类型
        sampleDealWay: null, // 样品处理方式
        deliveryType: null, // 报告领取方式
        serviceType: null, // 服务类型
        note: '', // 特殊说明
        stmtWay: null, // 结算类型
        isIvDdeliver: null, // 是否邮寄
        ivDdeliveryAddress: '', // 邮寄地址
        sendDate: null, // 商定检测日期
        noteInner: '', // 内部特殊说明
        etmtType: 'etmt_type_unvs', // 委托协议书类型
        scac: '',
        testAddress: '', // 检测地点
        sampleInfoList: [],
        basisTotalList: [],
        multiple: null
      },
      etmtTypeOptions: [],
      testTypeOptions: [],
      areaTreeData: [],
      addressOptions: [],
      userOptions: [],
      rules: {},
      detailLoading: false,
      submitLoading: false,
      sampleVisible: false
    };
  },
  computed: {},
  watch: {
    async visible(val) {
      if (val) {
        await this.getDictsByCode('test_type', 'testTypeOptions');
        await this.getUserOpetions();

        if (this.activeId) {
          this.getDetailData();
        }
      }
    }
  },
  methods: {
    // 编辑时获取详情
    async getDetailData() {
      this.detailLoading = true;

      try {
        const { data } = await getEntrustmentSet({ id: this.activeId });
        const testType = data?.testType ? data.testType.split(',') : [];
        const entrustmentUserIds = data?.entrustmentUserList ? data.entrustmentUserList.map(item => item.userId) : [];
        const sampleInfoList = data?.sampleInfoList || [];

        sampleInfoList.forEach(item => {
          if (item.imgs) {
            if (this.isJSONObjectOrArray(item.imgs)) {
              const allFiles = JSON.parse(item.imgs);
              item.imgs = allFiles.imgs;
              item.files = allFiles.files;
            } else {
              item.imgs = item.imgs;
              item.files = [];
            }
          } else {
            item.imgs = '';
            item.files = [];
          }
        });

        this.editForm = { ...this.editForm, ...data, testType, entrustmentUserIds };
        this.editForm.sampleInfoList.forEach(item => {
          if (item.imgs) {
            item.imgList = item.imgs.split(',').map(item => {
              return this.$imgUrl + item;
            });
          } else {
            item.imgList = [];
          }
        });
        this.$nextTick(() => {
          this.$refs.editForm.clearValidate();
        });
      } finally {
        this.detailLoading = false;
      }
    },
    isJSONObjectOrArray(str) {
      if (typeof str !== 'string') return false;
      try {
        const parsed = JSON.parse(str);
        return typeof parsed === 'object' && parsed !== null;
      } catch (e) {
        return false;
      }
    },
    async getUserOpetions() {
      const { data: testedByData } = await getUserListByCode({ roleCode: 'JCY' });
      const { data: auditedByData } = await getUserListByCode({ roleCode: 'SHY' });
      const { data: approvedByData } = await getUserListByCode({ roleCode: 'PZY' });
      const testedBys = testedByData?.list || [];
      const auditedBys = auditedByData?.list || [];
      const approvedBys = approvedByData?.list || [];

      // 使用 Map 根据 id 去重
      const userMap = new Map();
      [...testedBys, ...auditedBys, ...approvedBys].forEach(user => {
        if (!userMap.has(user.id)) {
          userMap.set(user.id, user);
        }
      });

      this.userOptions = Array.from(userMap.values());
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data;
    }
  },

  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.el-button--mini.is-circle {
  padding: 5px;
}

.word-table {
  margin: 0 40px 20px 40px;
}
.el-select {
  width: 100%;
}

.img-list {
  .el-image {
    margin: 0 10px 10px 0;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
  }
}

.break-radio {
  .el-radio {
    margin-bottom: 10px;
  }
  .radio-line {
    display: flex;
    align-items: center;
    .el-radio {
      margin-bottom: 0;
    }
  }
}
</style>
